//@ts-ignore
import FileUploader from 'react-firebase-file-uploader'

import { makeStyles, CircularProgress } from '@material-ui/core'

import { AttachFile as FileIcon } from '@material-ui/icons'

import { useAuth, useBoolean } from 'hooks'
import { PlaybookType } from 'app/types'

import { uuid, getPlaybookStorage, updateFiles } from 'modules'

const useStyles = makeStyles({
    wrapper: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginRight: '10px',
        padding: '0',
        width: 'auto'
    },
    label: {
        margin: '-5px -15px',
        padding: '5px 15px',
        color: '#2D9CDB'
    },
    fileIcon: {
        color: '#2D9CDB',
        marginTop: '4px'
    }
})

type FileType = {
    id: string
    name: string
    uid: string
    url: string
}

type Props = {
    playbook: PlaybookType
}

const ALLOWED_FORMATS = 'image/png, image/jpeg, application/pdf, application/json, application/zip'

export const PlaybookFileUploader = ({ playbook }: Props) => {
    const classes = useStyles()

    const loading = useBoolean()

    const { orgId, uid } = useAuth()

    const storageRef = getPlaybookStorage(orgId, uid, playbook.id)

    const handleUploadSuccess = (name: string) => {
        storageRef
            .child(name)
            .getDownloadURL()
            .then((url: string) => {
                const files: Array<FileType> = (playbook.files ?? []).concat({
                    id: uuid(),
                    uid,
                    name,
                    url
                })
                updateFiles(playbook.id, files).then(() => loading.setFalse())
            })
    }

    return (
        <label className={classes.wrapper} data-cy="file-uploader-wrapper">
            {loading.isTrue && <CircularProgress size={14} />}
            <FileUploader
                hidden
                name="logoUploader"
                accept={ALLOWED_FORMATS}
                metadata={{ cacheControl: 'max-age=604800' }}
                storageRef={storageRef}
                onUploadStart={() => loading.setTrue()}
                onUploadSuccess={handleUploadSuccess}
                data-cy="file-uploader"
            />

            <FileIcon fontSize="small" className={classes.fileIcon} data-cy="file-icon" />
        </label>
    )
}
